export const getChartColors = () => {
    return [
        "#4A3AFF", "#962DFF", "#BF85FF", "#EFB8C8", "#7E75FF", 
        "#635AE0", "#6D3FA0", "#9760D7", "#7D5260","#FFD8E4", 
        "#996A78", "#8069BF", "#9A83DB", "#B69DF7", "#CFBCFF", 
        "#F6EEFF"
    ];
};
